export default __webpack_public_path__ + "static/media/premium_m_02.71390a9a.jpg";